<script>
export default {
  name: 'display-item',
  props: {
    label: ''
  }
}
</script>

<template>
  <div class="display-item">
    <div
      class="label"
      v-if="label"
    >{{ label }}</div>
    <div class="content">
      <slot></slot>
    </div>
  </div>
</template>



// WEBPACK FOOTER //
// src/components/display-item.vue